import { Modal } from '@mui/material';
import React from 'react';

import { FacilityChooser } from './components/facilityChooser';
import { IFacilityChooserProps } from './components/facilityChooser/FacilityChooser.types';
import {
  FACILITY_ACTION_TYPES,
  useFacilityContext,
} from './contexts/FacilityProvider';

export default function FacilityChooserModal() {
  const {
    dispatch: facilityDispatch,
    state: { selectedFacility, facilityList },
  } = useFacilityContext();
  const onFacilitySelect: IFacilityChooserProps['onApply'] = (v) => {
    facilityDispatch({
      type: FACILITY_ACTION_TYPES.SET_SELECTED_FACILITY,
      payload: v,
    });
  };
  return (
    <Modal
      open={!selectedFacility}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <FacilityChooser
        options={
          facilityList?.map?.((d: any) => ({
            id: d,
            name: d,
          })) || []
        }
        onApply={onFacilitySelect}
        value={selectedFacility}
      />
    </Modal>
  );
}
